import { render, staticRenderFns } from "./DmhStart.vue?vue&type=template&id=20578b54"
import script from "./DmhStart.vue?vue&type=script&lang=js"
export * from "./DmhStart.vue?vue&type=script&lang=js"
import style0 from "./DmhStart.vue?vue&type=style&index=0&id=20578b54&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports